var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',{staticClass:"layout-container"},[_c('el-header',{staticClass:"header-style"},[_vm._t("header")],2),_vm._v(" "),_c('el-main',{staticClass:"main-style"},[_vm._t("default")],2),_vm._v(" "),_c('el-footer',{staticClass:"footer-style"},[_vm._t("footer")],2),_vm._v(" "),_vm._t("drawer")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7635c402","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/common/ResourceLayout.vue
// module id = null
// module chunks = 